import React from 'react';
import DataServiceTabNav from '../Components/DataService/DataServiceTabNav';
import HistoryComponent from '../Components/DataService/HistoryComponent';

function DataServiceHistoryPage() {
  return (
    <div className="bg-slate-950 text-slate-100">
      <DataServiceTabNav />
      <HistoryComponent />
    </div>
  );
}

export default DataServiceHistoryPage;


